<template>
<div class="Classroom_list no-trans" v-loading="loading">
    <div class="Classroom_list_box">
         <div class="title_box">
            <!-- <img src="../../assets/img/login/Frame.png" alt=""> -->
            <router-link class="span1 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/home">首页</router-link> > <router-link class="span2 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/Classroom">法律课堂</router-link> > <span class="span2" aria-current="page">视频课堂</span>
         </div>
         <div class="check_box">
            <div class="check_felx">
                <div class="check_title">一级分类</div>
                <div class="check_list" :class="{'check_list_minh':yjfl_show,'check_list_maxh':!yjfl_show}">
                    <div class="check_item" :class="{'check_item_ac':yjfl_ac.id==item.id}" v-for="(item,index) in yjfl_list" :key="index" @click="handle_yjfl_ac(item)">{{ item.title }}</div>
                </div>
                <div class="check_show" :class="{'check_show2':yjfl_show}" role="button" tabindex="0" :aria-expanded="yjfl_show" aria-label="展开或收起一级分类" @keydown.enter.prevent="handle_yjfl_show" @click="handle_yjfl_show">
                    <img src="@/assets/img/index/legal/check_show.png" alt="">
                </div>
            </div>
            <div class="check_felx" v-if="yjfl_ac.id">
                <div class="check_title">二级分类</div>
                <div class="check_list" :class="{'check_list_minh':ejfl_show,'check_list_maxh':!ejfl_show}">
                    <div class="check_item" :class="{'check_item_ac':ejfl_ac.id==item.id}" v-for="(item,index) in ejfl_list" :key="index"  @click="handle_ejfl_ac(item)">{{ item.title }}</div>
                </div>
                <div class="check_show" :class="{'check_show2':ejfl_show}" role="button" tabindex="0" :aria-expanded="ejfl_show" aria-label="展开或收起二级分类" @keydown.enter.prevent="handle_ejfl_show" @click="handle_ejfl_show">
                    <img src="@/assets/img/index/legal/check_show.png" alt="">
                </div>
            </div>
            <div class="check_felx">
                <div class="check_title">关键字</div>
                <div class="check_keyword">
                    <input type="search" v-model="keyword" placeholder="搜索视频课程" aria-label="搜索视频课程" @keyup.enter="handle_keyword">
                    <div class="btns" @click="handle_keyword">搜索</div>
                </div>
            </div>

            <div class="check_felx" :class="{mobile_no_selection:!yjfl_ac.id && !ejfl_ac.id && !keyword}">
                <div class="check_title">已选择</div>
                <div class="check_ac_flex">
                    <div class="check_ac_box" v-if="yjfl_ac.id">
                        {{ yjfl_ac.title }}
                        <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('yjfl_ac')">
                    </div>
                    <div class="check_ac_box" v-if="ejfl_ac.id">
                        {{ ejfl_ac.title }}
                        <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('ejfl_ac')">
                    </div>
                    <!-- <div class="check_ac_text"></div> -->
                    <div class="chack_ac_clear" @click="handle_clear">清空</div>
                </div>
            </div>
         </div>
         <div class="list_box">
            <div v-if="mobile_view" class="mobile_results" aria-live="polite"><span>视频课程</span><span>共 {{ total }} 门</span></div>
            <div v-if="mobile_view && !loading && !list.length" class="mobile_empty"><i class="el-icon-search" aria-hidden="true"></i><div>暂无符合条件的课程</div><button type="button" @click="handle_clear">重置筛选</button></div>
            <div class="lite_item">
                <div class="items" v-for="(item,index) in list" :key="index" role="link" tabindex="0" @keydown.enter.prevent="handle_detial(item)" @click="handle_detial(item)">
                    <div class="item_imgs">
                        <!-- <img src="../../../assets/img/index/law/bg1.png" alt=""> -->
                         <img :src="item.thumb" alt="">
                         <i v-if="mobile_view" class="el-icon-video-play mobile_play" aria-hidden="true"></i>
                    </div>
                    <div class="item_info">
                        <div class="item_title">
                            {{ item.title }}
                        </div>
                        <div class="tage_flex">
                            <div class="teges">
                                <img src="../../../assets/img/index/comments_case/see.png" alt="">
                                {{ item.views }}
                            </div>
                            <div class="teges">
                                <img src="../../../assets/img/index/comments_case/time.png" alt="">
                                {{ mobile_view ? String(item.pub_time || '').split(' ')[0] : item.pub_time }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="items2"></div>
            </div>
            
            <div class="pages_box">
                <div class="btns" @click="handle_pages(1)">首页</div>
                <site-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pages.page"
                    background
                    :page-size="pages.limit"
                    layout="prev, pager, next"
                    :total="total">
                </site-pagination>
                <div class="btns"  @click="handle_pages(last_page)">尾页</div>
            </div>
             
         </div>
    </div>
</div>
</template>
<script>
import {
    mapState
} from 'vuex'
 
 

export default {
    components: {

    },
    name: "homes",
    data() {
        return {
            loading:false,
            yjfl_list:[],//办理地址列表
            yjfl_ac:{},//办理地址的选中
            yjfl_show:false,//办理地址的显示隐藏

            ejfl_list:[],//业务类型
            ejfl_ac:{},//业务类型的选中
            ejfl_show:false,//业务类型的显示隐藏
            list:[],
            total:0,
            last_page:0,
            keyword:'',//关键字
            pages:{
                page:1,
                limit:9,
            },
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {
        this.get_type_list()
        if(this.$route.query.items_id){

        }else{
            this.get_list()
        }
    },
    methods: {
        get_type_list(){
            this.loading=true
            this.$api("lessonTypeList", {
                 
			}, "get").then((res) => {
                this.loading = false
                console.log('法律课堂分类',res)
                if (res.code == 1) {
                    this.yjfl_list=res.data
                    if(this.$route.query.item_id){
                        this.yjfl_list.forEach(item=>{
                            if(item.id==this.$route.query.item_id){
                                this.yjfl_ac=item
                                this.ejfl_list=item.child
                                if(this.$route.query.items_id){
                                    item.child.forEach(items=>{
                                        if(items.id==this.$route.query.items_id){
                                            this.ejfl_ac=items
                                        }
                                    })
                                }else{
                                    this.ejfl_ac={}
                                }
                                this.get_list()

                            }
                        })
                    }else{
                        this.yjfl_ac={}
                    }
                    
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_keyword(){
            this.pages.page=1
            this.get_list()
        },
        get_list(){
            this.loading=true
            this.$api("lessonList", {
                type:1,
                ...this.pages,
                cateid:this.yjfl_ac.id||0,
                cateid2:this.ejfl_ac.id||0,
                keyword:this.keyword||'',
			}, "get").then((res) => {
                this.loading = false
                console.log('法律课堂列表1',res)
                if (res.code == 1) {
                    this.list=res.data.data
                    this.total=res.data.total
                    this.last_page=res.data.last_page
                } else {
                    alertErr(res.msg)
                }
            });
        },
        ac_clear(text){
            if(text=='yjfl_ac'){
                this.ejfl_list=[]
                this.ejfl_ac={}
            }
            this.pages.page=1
            this[text]={}
            this.get_list()
        },
        handle_clear(){
            this.keyword=''
            this.yjfl_ac={}
            this.ejfl_ac={}
           
            this.ejfl_list=[]
            this.pages.page=1
            this.get_list()
        },
        handle_yjfl_ac(item){
            this.yjfl_ac=item
            this.ejfl_list=item.child
            this.ejfl_ac={}
            this.pages.page=1
            this.get_list()

        },
        handle_yjfl_show(){
            this.yjfl_show=!this.yjfl_show
        },
        handle_ejfl_ac(item){
            this.ejfl_ac=item
            this.pages.page=1
            this.get_list()

        },
        handle_ejfl_show(){
            this.ejfl_show=!this.ejfl_show
        },
        handleSizeChange(e){
            console.log('条数',e)   
            this.get_list()

        },
        handleCurrentChange(e){
            console.log('页数',e)
            this.pages.page=e
            this.get_list()

        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
            this.get_list()

        },
        
        //咨询
        handle_check(item){
            this.$refs.legal_check.handle_open()
        },
        handle_end(){
            console.log('回调')
        },
        handle_detial(item){
            this.$router.push({
                path:'/Classroom_list_video_detial',
                query:{
                    id:item.id
                }
            })
        },
    },

}
</script>
<style scoped lang="less">
.Classroom_list{
    width: 100%;
    // height: 680px;
    background-color: #F5F5F5;
    padding:21px ;
    padding-bottom: 100px;
    .Classroom_list_box{
        width: 1440px;
        margin: auto;
        .title_box{
            padding-bottom: 21px;

            display: flex;
            align-items: center;

            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            .span1{
                cursor: pointer;
                margin-right: 10px;
            }
            .span2{
                cursor: pointer;
                margin-left: 10px;
            }
            img{
                margin-right: 10px;
            }
        }
        .check_box{
            width: 1440px;
            // height: 261px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            padding:0 32px;
            .check_felx{
                display: flex;
                // align-items: center;
                padding: 24px 0px 14px 0;
                border-bottom: 1px solid #EEEEEE ;
                .check_title{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #999999;
                    width: 90px;
                    flex-shrink: 0;
                }
                .check_list{
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    .check_item{
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        margin-right: 40px;
                        margin-bottom: 10px;
                        &:hover{
                            color: #377CFD;
                        }
                    }
                    .check_item_ac{
                        color: #377CFD;
                    }
                }
                .check_list_maxh{
                    height: 60px;
                    overflow: hidden;
                }
                .check_list_minh{
                    min-height: 60px;
                }
                .check_show{
                    width: 20px;
                    height: 20px;
                    flex-shrink: 0;
                    img{
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                    }
                }
                .check_show2{
                    img{
                        transform: rotate(-180deg);
                    }
                }
                .check_ac_flex{
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    .check_ac_box{
                        // width: 102px;
                        padding: 0 10px;
                        height: 29px;
                        background: #F8F8F8;
                        border-radius: 0px 0px 0px 0px;
                        margin-right: 11px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        
                        font-weight: 400;
                        font-size: 14px;
                        color: #656565;
                        img{
                            width: 12px;
                            height: 12px;
                            margin-left: 14px;
                            cursor: pointer;
                        }

                    }
                    .chack_ac_clear{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .check_keyword{
                    display: flex;
                    align-items: center;
                    input{
                        width: 200px;
                        height: 32px;
                        border: 1px solid #377CFD;
                        border-radius: 5px;
                        padding: 10px;
                        margin-right: 20px;
                        font-size: 15px;
                    }
                    .btns{
                        width: 92px;
                        height: 32px;
                        background: #FFFFFF;
                        border-radius: 4px 4px 4px 4px;
                        border: 1px solid #377CFD;
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #377CFD;
                        text-align: center;
                        line-height: 32px;
                    }
                }
            }
        }
        .list_box{
            
            padding-top: 24px;
            .lite_item{
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                justify-content: space-between;
                .items2{
                    width: 453px;
                }
                .items{
                    width: 453px;
                    height: 390px;
                    background: #FFFFFF;
                    box-shadow: 0px 0px 40px 1px rgba(55,124,253,0.08);
                    border-radius: 8px 8px 8px 8px;
                    margin-bottom: 40px;
                    .item_imgs{
                        width: 100%;
                        height: 255px;
                        img{
                            width: 100%;
                            height: 255px;
                        }
                    }
                }
                .item_info{
                    padding: 20px 24px 24px 24px;
                    .item_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 20px;
                        color: #000B33;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp:2;
                        -webkit-box-orient: vertical;
                    }
                    .tage_flex{
                        display: flex;
                        align-items: center;
                        padding-top: 18px;
                        .teges{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                            margin-right: 24px;
                            img{
                                height: 15px;
                                margin-right: 8px;
                            }
                        }

                    }
                }
            }

            
        }
        .pages_box{
            width: 100%;
            height: 100px;
            // background-color: red;
            display: flex;
            align-items: center;
            justify-content: center;
            /deep/.el-pagination{
                .el-pager{
                    .number {
                        background-color: #FFFFFF;
                    }
                    .active{
                        background-color: #377CFD;
                    }
                }
            }
            .btns{
                width: 40px;
                height: 32px;
                background: #FFFFFF;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #EEEEEE;  
                font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                font-weight: normal;
                font-size: 14px;
                color: #7A7A7A;
                text-align: center;
                line-height: 32px;
                cursor: pointer;
            }
        }
         
        
        
    }
    
}

</style>
<style scoped lang="less">
@import "../../../styles/mobile-patterns.less";

@media (max-width: 1024px) {
    .Classroom_list.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding: 16px;
        padding-bottom: 16px;
    }
    .Classroom_list.no-trans .Classroom_list_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .Classroom_list.no-trans .Classroom_list_box .title_box {
        padding-bottom: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
    }
    .Classroom_list.no-trans .Classroom_list_box .title_box .span1 {
        margin-right: 10px;
    }
    .Classroom_list.no-trans .Classroom_list_box .title_box .span2 {
        margin-left: 10px;
    }
    .Classroom_list.no-trans .Classroom_list_box .title_box img {
        margin-right: 10px;
    }
    .Classroom_list.no-trans .Classroom_list_box .check_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
    }
    .Classroom_list.no-trans .Classroom_list_box .check_box .check_felx {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 16px 0px 14px 0;
    }
    .Classroom_list.no-trans .Classroom_list_box .check_box .check_felx .check_title {
        font-size: 14px;
        width: 90px;
    }
    .Classroom_list.no-trans .Classroom_list_box .check_box .check_felx .check_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        max-width: 100%;
    }
    .Classroom_list.no-trans .Classroom_list_box .check_box .check_felx .check_list .check_item {
        font-size: 14px;
        margin-right: 16px;
        margin-bottom: 10px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .Classroom_list.no-trans .Classroom_list_box .check_box .check_felx .check_list_maxh {
        height: 60px;
    }
    .Classroom_list.no-trans .Classroom_list_box .check_box .check_felx .check_show {
        width: 20px;
        height: 20px;
    }
    .Classroom_list.no-trans .Classroom_list_box .check_box .check_felx .check_show img {
        width: 20px;
        height: 20px;
    }
    .Classroom_list.no-trans .Classroom_list_box .check_box .check_felx .check_ac_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 10px;
    }
    .Classroom_list.no-trans .Classroom_list_box .check_box .check_felx .check_ac_flex .check_ac_box {
        padding: 0 10px;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        margin-right: 11px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        min-height: 29px;
    }
    .Classroom_list.no-trans .Classroom_list_box .check_box .check_felx .check_ac_flex .check_ac_box img {
        width: 12px;
        height: 12px;
        margin-left: 14px;
    }
    .Classroom_list.no-trans .Classroom_list_box .check_box .check_felx .check_ac_flex .chack_ac_clear {
        font-size: 14px;
    }
    .Classroom_list.no-trans .Classroom_list_box .check_box .check_felx .check_keyword {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .Classroom_list.no-trans .Classroom_list_box .check_box .check_felx .check_keyword input {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 32px;
        border-radius: 5px;
        padding: 10px;
        margin-right: 16px;
        font-size: 15px;
    }
    .Classroom_list.no-trans .Classroom_list_box .check_box .check_felx .check_keyword .btns {
        width: 92px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .Classroom_list.no-trans .Classroom_list_box .list_box {
        padding-top: 16px;
    }
    .Classroom_list.no-trans .Classroom_list_box .list_box .lite_item {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .Classroom_list.no-trans .Classroom_list_box .list_box .lite_item .items2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .Classroom_list.no-trans .Classroom_list_box .list_box .lite_item .items {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        margin-bottom: 16px;
    }
    .Classroom_list.no-trans .Classroom_list_box .list_box .lite_item .items .item_imgs {
        min-height: 0;
        height: auto;
    }
    .Classroom_list.no-trans .Classroom_list_box .list_box .lite_item .items .item_imgs img {
        min-height: 0;
        height: auto;
    }
    .Classroom_list.no-trans .Classroom_list_box .list_box .lite_item .item_info {
        padding: 16px 16px 16px 16px;
    }
    .Classroom_list.no-trans .Classroom_list_box .list_box .lite_item .item_info .item_title {
        font-size: 20px;
    }
    .Classroom_list.no-trans .Classroom_list_box .list_box .lite_item .item_info .tage_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .Classroom_list.no-trans .Classroom_list_box .list_box .lite_item .item_info .tage_flex .teges {
        font-size: 14px;
        margin-right: 16px;
    }
    .Classroom_list.no-trans .Classroom_list_box .list_box .lite_item .item_info .tage_flex .teges img {
        height: 15px;
        margin-right: 8px;
    }
    .Classroom_list.no-trans .Classroom_list_box .pages_box {
        min-height: 0;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .Classroom_list.no-trans .Classroom_list_box .pages_box .btns {
        width: 40px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}

@media (max-width: 1024px) {
    .Classroom_list.no-trans .Classroom_list_box .check_box { .mobile-filters(); }
}
@media (max-width: 1024px) {
    .Classroom_list.no-trans {
        box-sizing: border-box; padding: 0 12px 28px;
        .Classroom_list_box {
            .title_box { min-height: 48px; padding: 0; gap: 4px 6px; font-size: 13px; }
            .title_box .breadcrumb_link { display: inline-flex; align-items: center; min-height: 44px; margin: 0; }
            .title_box .span2 { margin-left: 0; }
            .check_box .check_felx {
                grid-template-columns: 58px minmax(0, 1fr) 44px; gap: 0 4px; padding: 6px 0;
                .check_title { grid-column: auto; display: flex; align-items: center; min-height: 44px; }
                .check_list .check_item { padding-left: 8px; padding-right: 8px; overflow-wrap: anywhere; }
                .check_keyword, .check_ac_flex { grid-column: ~"2 / -1"; }
                .check_keyword .btns { flex-basis: 56px; width: 56px; }
                .check_ac_flex { gap: 4px; margin: 0; }
                .check_ac_flex .check_ac_box { flex-wrap: nowrap; gap: 0; overflow-wrap: anywhere; }
                &.mobile_no_selection { display: none; }
            }
            .list_box {
                padding-top: 8px;
                .mobile_results { display: flex; justify-content: space-between; align-items: center; gap: 8px; min-height: 52px; color: #303846; font-size: 17px; font-weight: 600; }
                .mobile_results span:last-child { font-size: 13px; color: #7b8491; font-weight: 400; }
                .mobile_empty { display: flex; flex-direction: column; align-items: center; gap: 12px; padding: 36px 0; font-size: 14px; color: #7b8491; background: #fff; }
                .mobile_empty i { font-size: 32px; color: #aab5c4; }
                .mobile_empty button { min-height: 44px; padding: 0 12px; border: 0; background: transparent; color: #377cfd; font-size: 14px; cursor: pointer; }
                .lite_item {
                    display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); align-items: stretch; gap: 16px 12px;
                    .items2 { display: none; }
                    .items {
                        box-sizing: border-box; width: 100%; min-width: 0; height: auto; margin: 0; overflow: hidden; border: 1px solid #e7ecf2; border-radius: 6px; box-shadow: none; cursor: pointer;
                        .item_imgs { position: relative; width: 100%; height: auto; aspect-ratio: ~"16 / 10"; overflow: hidden; background: #e9eef5; }
                        .item_imgs img { display: block; width: 100%; height: 100%; object-fit: cover; }
                        .item_imgs .mobile_play { position: absolute; right: 8px; bottom: 8px; font-size: 25px; color: #fff; border-radius: 50%; background: rgba(0,0,0,.3); }
                        .item_info {
                            min-width: 0; padding: 10px;
                            .item_title { height: 48px; font-size: 15px; line-height: 24px; overflow-wrap: anywhere; -webkit-line-clamp: 2; }
                            .tage_flex { display: flex; flex-direction: column; align-items: flex-start; gap: 4px; padding-top: 8px; }
                            .tage_flex .teges { display: flex; align-items: center; gap: 5px; margin: 0; font-size: 13px; line-height: 20px; color: #7b8491; overflow-wrap: anywhere; }
                            .tage_flex .teges img { width: 14px; height: 14px; object-fit: contain; margin: 0; }
                        }
                    }
                }
            }
            .pages_box { padding-top: 24px; }
        }
        [role="link"]:focus-visible, [role="button"]:focus-visible { outline: 2px solid #377cfd; outline-offset: -2px; }
    }
}
@media (min-width: 769px) and (max-width: 1024px) {
    .Classroom_list.no-trans .Classroom_list_box .list_box .lite_item { grid-template-columns: repeat(3, minmax(0, 1fr)); }
}
</style>
